import styled from "styled-components";

export const StyledActionFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  padding: 16px 24px;
`;
